<template>
	<div class="ReCellByAddr">
		
			<div class="ReCellByAddr-input d-flex px-0">
				<div class="form-group mr-3 w-100">
				
					<!-- <input type="text" placeholder="Введите адрес" class="form-control"> -->

					<base-input
						placeholder="Введите адрес"
						addon-left-icon="tim-icons icon-zoom-split"
						autocomplete="off"
						ref="addr"
						v-model="address"
					>
					</base-input>

				</div>
			</div>
		

		<div class="ReCellByAddr-input d-flex px-0" style="align-items: center;">
			<el-select
				class="w-100 select-primary overflow-overlay"
				size="large"
				filterable
				placeholder="Выбрать ячейку"
				v-model="bufferValue"
			>
				<el-option
					v-for="(el_opt, el_index) in options"
					class="select-primary"
					:value="el_opt.value"
					:label="el_opt.label"
					:key="el_index"
				>
				</el-option>
			</el-select>
			<base-button type="danger" class="no-border my-0" simple icon @click="bufferValue = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>

	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	import mapSettings from 'src/conf/yandexmap.js';
	import { loadYmap } from 'vue-yandex-maps';
	export default {
		name: 'ReCellByAddr',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: [String, Number],
			options:{ 
				type: Array,
				default: function(){return [];},
			},
			settings:{
				type: Object,
				default(){
					return mapSettings
					/*{
						apiKey: '7f037fcc-21f0-4c1b-ad6e-1f292ef45a2f',
						lang: 'ru_RU',
						coordorder: 'latlong',
						version: '2.1'
					}*/

				},
			},			
		},
		data () {
			return {
				ver: 1,
				address: '',
				bufferValue: null,
				suggestView: null,
			}
		},
		watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
		},
		computed: {

		},
		methods: {
			buildAddressObj(context){
				let strAddr = context.getAddressLine();
				let masCoords = context.geometry.getCoordinates();
				let Localities = context.getLocalities();
				let Thoroughfare = context.getThoroughfare();
				let PremiseNumber = context.getPremiseNumber();
				let objAdministrativeAreas = context.getAdministrativeAreas();
				return {
					'text': strAddr,
					'value': masCoords.join('#'),
					'objAdministrativeAreas': objAdministrativeAreas,
					'Localities': Localities[0],
					'Thoroughfare': Thoroughfare,
					'PremiseNumber': PremiseNumber,
				};
			},			
			selectAddress(event){
				
				let address = event.originalEvent.item.value;
				ymaps.geocode(
					address,
					{results: 1, boundedBy:[[59.40838788408754, 28.182632410903928],[60.785204345571046, 31.275283778091396]], strictBounds:true}
				).then(res => { // boundedBy - Прямоугольная область на карте, где предположительно находится искомый объект. strictBounds:true - Искать только внутри области, заданной опцией boundedBy.
					this.masDataOpt = [];
					this.bInSearch = false;
					res.geoObjects.each((context)=>{
						let [lat, lng] = context.geometry.getCoordinates();
						this.$GVO.ApiCall('MAP_CELLS.GET_CELLS_FROM_POINT',{ flt:{lat, lng}}).then(result=>{
							if(result && result.data && result.data[0]){
								this.bufferValue = result.data[0].id
							}
						})
					});
				}).catch(console.error);

				return true;				
			}
		},
		async mounted(){
			try{
				await loadYmap(this.settings);
				await ymaps.ready();
				this.suggestView = new ymaps.SuggestView(this.$refs.addr.$el.querySelector('input'),{results:10});
				// console.log(this.$refs.addr.value);
				this.suggestView.events.add('select', this.selectAddress );

			}catch (e){
				console.error(e);
				
			}
		}
	}
</script>
<style scoped>
	.ReCellByAddr{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
	.ReCellByAddr >>> ymaps {
		width: 700px!important;
	}
	@media (max-width: 810px) {	
		.ReCellByAddr >>> ymaps {
			width: 580px!important;
		}
	}

	@media (max-width: 670px) {	
		.ReCellByAddr-input {
			width: 100%;
			margin-bottom: 7px;
		}
		.ReCellByAddr >>> ymaps {
			width: 100%!important;
		}
		
		/*
		.form-options-group > div {
			margin-bottom: 5px;
		}
		*/
	}
</style>
